import React from 'react';
import { TrendingUp } from 'lucide-react';

const RevenueTrendChart = ({ trends = [] }) => {
  // Helper function to format currency
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '$0';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '$0';
    return `$${numAmount.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  };

  if (!trends || trends.length === 0) {
    return (
      <div className="rounded-2xl border border-gray-200/80 bg-white dark:border-gray-700 dark:bg-gray-900 shadow-sm p-4 sm:p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Revenue Trend</h3>
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">Platform bookings only</p>
        <div className="text-center py-12">
          <TrendingUp className="w-12 h-12 text-gray-400 dark:text-gray-500 mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">No revenue data available</p>
        </div>
      </div>
    );
  }

  const revenueData = trends.map(item => ({
    period: item.period,
    revenue: Number(item.revenue || 0)
  }));

  const maxRevenue = Math.max(...revenueData.map(d => d.revenue), 1);
  const minRevenue = Math.min(...revenueData.map(d => d.revenue), 0);

  return (
    <div className="rounded-2xl border border-gray-200/80 bg-white dark:border-gray-700 dark:bg-gray-900 shadow-sm p-4 sm:p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">Revenue Trend</h3>
        <TrendingUp className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">Platform bookings only</p>
      <div className="space-y-3">
        {revenueData.map((item, index) => {
          const percentage = maxRevenue > 0 ? (item.revenue / maxRevenue) * 100 : 0;
          return (
            <div key={index} className="space-y-1">
              <div className="flex items-center justify-between text-sm">
                <span className="text-gray-600 dark:text-gray-400 font-medium">{item.period}</span>
                <span className="text-gray-900 dark:text-gray-50 font-semibold">{formatCurrency(item.revenue)}</span>
              </div>
              <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
                <div
                  className="bg-gradient-to-r from-emerald-500 to-emerald-600 h-2.5 rounded-full transition-all duration-500"
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600 dark:text-gray-400">Total</span>
          <span className="text-lg font-bold text-gray-900 dark:text-gray-50">
            {formatCurrency(revenueData.reduce((sum, item) => sum + item.revenue, 0))}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RevenueTrendChart;
